import axios from "axios";

export async function handleGetDetailsResponse(formResponseId, setDetailsResponse , setLoading) {


    setLoading(true)
    

    const token = localStorage.getItem("authToken");

    try {
        const response = await axios.get(
            `https://formmaker-api.altynlogistics.com/api/form/response/${formResponseId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        setLoading(false)
        setDetailsResponse(response.data.output.responseData);

        return { data: response.data, error: null };
    } catch (err) {
        setLoading(false)
        return { data: null, error: err };
    }
}
